import { makeFieldSchema } from '../../../extensions/types';

export type AutocompleteOption = {
  id: string;
  name: string;
  description: string;
};

export type PickerMessage = {
  line: string;
  severity: 'info' | 'warning' | 'error';
};

export type FetchOptionsResponse = {
  options: AutocompleteOption[];
  ok: boolean;
};

export const retrievalErrorPickerMessage: {
  key: string;
  value: PickerMessage;
} = {
  key: 'retrieval_error',
  value: {
    line: 'Error while fetching values. Retry later or contact platform team.',
    severity: 'error',
  },
};
/**
 * @public
 */
export const CustomUrlPickerFieldSchema = makeFieldSchema({
  output: z => z.array(z.any()),
  uiOptions: z =>
    z.object({
      allowArbitraryValues: z.boolean().optional(),
      maxNumberToSelect: z.number().optional(),
      selectedField: z.string(),
    }),
});

/**
 * The input props that can be specified under `ui:options` for the
 * `CustomUrlPicker` field extension.
 *
 * @public
 */
export type CustomUrlPickerUiOptions = NonNullable<
  (typeof CustomUrlPickerFieldSchema.TProps.uiSchema)['ui:options']
>;

export type CustomUrlPickerProps = typeof CustomUrlPickerFieldSchema.TProps;

export const CustomUrlPickerSchema = CustomUrlPickerFieldSchema.schema;
